import React from 'react';

import Sidebar from '../components/nav/Sidebar';

export const AuthenticatedLayout = ({ children }) => {
    return (
        <div className="bg-white">
            <Sidebar>{children}</Sidebar>
        </div>
    );
};

export default AuthenticatedLayout;
